import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-filter-tag',
  templateUrl: './filter-tag.component.html',
  styleUrls: ['./filter-tag.component.scss'],
})
export class FilterTagComponent {
  @Input() label: string = '';
  @Input() value: string = '';
}

